import { Typography } from "@mui/material";
import { PrimaryPaper } from "Components/Shared/PrimaryPaper";
import type { ReactNode } from "react";

type Props = {
  icon: ReactNode;
  title: string;
  description: string;
};

export const InfoCard = ({ icon, title, description }: Props) => (
  <PrimaryPaper
    sx={{
      height: "100%",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      textAlign: "center",
      gap: 4,
      p: 6,
    }}
  >
    {icon}
    <Typography variant="h6">{title}</Typography>
    <Typography>{description}</Typography>
  </PrimaryPaper>
);
